const specialties = {
  hy: "Hatha Yoga",
  vn: "Vinyasa Yoga",
  as: "Ashtanga Yoga",
  ky: "Kundalini Yoga",
  iy: "Iyengar Yoga",
  bi: "Bikram Yoga",
  yi: "Yin Yoga",
  re: "Yoga Restaurativo",
};

export default specialties;
